<script>
import animation from '../partials/components/animate.vue';
import magnetic from '../partials/components/Magnetic.vue';
import wavyLine from '../partials/components/wavy-line.vue';
import hero from '../partials/modules/hero-riverwatch.vue';
import scrollingArticles from '../partials/modules/scrolling-articles.vue';
import newsletter from '../partials/modules/newsletter.vue';
import parallaxBg from '../partials/components/ParallaxBg.vue';
import zoomIn from '../partials/components/animations/ZoomIn.vue';

export default {
    components: {
        animation,
        magnetic,
        wavyLine,
        hero,
        scrollingArticles,
        newsletter,
        parallaxBg,
        zoomIn
    }
};
</script>
